import { AiOutlineCloudUpload } from 'react-icons/ai';
import { AiOutlineFundView } from 'react-icons/ai';
import { ImUserTie } from 'react-icons/im';
import { MdOutlineDomainAdd } from 'react-icons/md';

const tiles = [
  // {
  //   sNo: 1,
  //   link: '/common/clauseUploadList?documentType=masterProcedureClause5&heading=MASTER PROCEDURE',
  //   isLink: true,
  //   clauseNo: 5,
  //   icon: <AiOutlineCloudUpload size="5rem" color="#135089" />,
  //   p: 'MASTER',
  //   span: 'PROCEDURE',
  //   isIcon: true,
  // },
  {
    sNo: 1,
    link: '/admin/masterlistofdepartment?filter=createdAt',
    isLink: true,
    clauseNo: 4,
    p: 'Master List Of',
    span: 'Department',
    icon: <MdOutlineDomainAdd size="5rem" color="#343a40" />,
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/admin/employee_list?filter=createdAt',
    isLink: true,
    p: 'MASTER LIST OF',
    span: 'EMPLOYEE',
    isIcon: true,
    icon: <ImUserTie size="5rem" color="#1864ab" />,
  },
  {
    sNo: 2,
    link: '/admin/employeeStaff_list?filter=createdAt',
    isLink: true,
    p: 'MASTER LIST OF',
    span: 'EMPLOYEE STAFF',
    isIcon: true,
    icon: <ImUserTie size="5rem" color="#1864ab" />,
  },
];

export default tiles;
